// Compact inline package progress pill: "consumed/total · expires date".
// Amber tint when the reminder fires; neutral otherwise. Hidden when the
// package data is missing or not ok (optional-first).
import { useTranslation } from "react-i18next";
import type { PackageProgress } from "../api/types";
import { cn } from "../lib/cn";

export function PackageBadge({ pkg }: { pkg: PackageProgress | null | undefined }) {
  const { t } = useTranslation("packages");
  if (!pkg?.ok) return null;
  const amber = pkg.reminder?.tone === "amber";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-pill px-2 py-0.5 text-[0.7rem] font-bold",
        amber ? "bg-ember-soft text-ember-700" : "bg-surface-sunken text-body-soft",
      )}
    >
      {pkg.consumed}/{pkg.total_sessions}
      {pkg.expires_on && (
        <span>· {t("expiresLabel", { date: pkg.expires_on })}</span>
      )}
    </span>
  );
}
